import React, { Fragment } from 'react';

const TimeWrapper = ({ time, children }) => (
    !time
        ? children
        : (
            <span
                date-time={time.format()}
                title={time.format()}
            >
                {children}
            </span>
        )
);

export default TimeWrapper;
